const mLogin = {
  mLogin: {
    alerts: {
      handleAuthentication: {
        error: 'Los datos ingresados son incorrectos.'
      }
    },

    buttonPrimary: 'ACCEDER',

    inputs: {
      contraseña: {
        placeholder: 'Contraseña'
      },

      usuario: {
        placeholder: 'Usuario'
      }
    },

    forgetPassword: '¿Olvidaste tu contraseña? Recuperar',

    validation: {
      email: {
        email: 'El email ingresado no es una cuenta válida.',
        required: 'El usuario es requerido.'
      },

      password: {
        required: 'La contraseña es requerida.'
      }
    }
  }
}

export default mLogin
